import Table from "react-data-table-component";

const DataTable = ({ columns, data = [], loading = false, paginationTotalRows = 0, defaultSortField=null, defaultSortAsc=false, setPerPage = () => null, setPage = () => null, setSortColumn = () => null, setSortDirection = () => null, customStyles = new Object() }) => {

    return (
        <div id="user-list-table">
            <Table
                columns={columns}
                data={data}
                progressPending={loading}
                pagination
                paginationServer
                paginationTotalRows={paginationTotalRows}
                onChangeRowsPerPage={newPerPage => {
                    setPerPage(newPerPage);
                    setPage(1);
                }}
                onChangePage={page => setPage(page)}
                sortServer
                onSort={(column, direction) => {
                    setSortColumn(column.sortField);
                    setSortDirection(direction);
                }}
                defaultSortField={defaultSortField}
                defaultSortAsc={defaultSortAsc}
                highlightOnHover
                striped
                progressComponent={
                    <div className="d-flex justify-content-center align-items-center" style={{ height: "calc(100vh - 280px)" }}>
                        <div className="spinnerInner"></div>
                    </div>
                }
                customStyles={customStyles}
            />
        </div>
    )
}

export default DataTable